/* Toni Pons × Judge.me — canonical behavior layer */
(function(){
  'use strict';

  var observer=null;
  var observedRoot=null;
  var queued=false;

  function isArabic(){
    var html=document.documentElement;
    var lang=(html.getAttribute('lang')||'').toLowerCase();
    return html.getAttribute('dir')==='rtl'||lang==='ar'||lang.indexOf('ar-')===0;
  }

  function getStickyOffset(){
    var max=0;
    document.querySelectorAll('header,.header-wrapper,.shopify-section-header-sticky,.section-header').forEach(function(el){
      var style=window.getComputedStyle(el);
      if(style.position!=='fixed'&&style.position!=='sticky') return;
      var rect=el.getBoundingClientRect();
      if(rect.bottom>0&&rect.top<=2) max=Math.max(max,rect.bottom);
    });
    return Math.max(0,Math.round(max));
  }

  function updateStickyOffset(){
    document.documentElement.style.setProperty('--tp-jdgm-sticky-offset',getStickyOffset()+'px');
  }

  function cleanDisplayName(root){
    root.querySelectorAll('.jdgm-form__fieldset label').forEach(function(label){
      var text=(label.textContent||'').replace(/\s+/g,' ').trim();
      if(!/اسم العرض|اسمك في التقييم/.test(text)) return;
      if(label.dataset.tpJdgmNameLabel==='true') return;
      label.childNodes.forEach(function(node){
        if(node.nodeType===Node.TEXT_NODE&&/اسم العرض|اسمك في التقييم/.test(node.nodeValue||'')){
          node.nodeValue='اسمك في التقييم ';
        }
      });
      label.dataset.tpJdgmNameLabel='true';
    });
  }

  function localizeReviewCountLabels(scope){
    if(!isArabic()) return;
    (scope||document).querySelectorAll('.jdgm-prev-badge__text,.jdgm-preview-badge__text').forEach(function(el){
      var badge=el.closest('.jdgm-prev-badge,.jdgm-preview-badge');
      var count=badge&&badge.getAttribute('data-number-of-reviews');
      if(!count){
        var match=(el.textContent||'').match(/\d[\d,]*/);
        count=match?match[0]:'';
      }
      if(!count) return;
      var localized=count+' مراجعة';
      if((el.textContent||'').trim()!==localized) el.textContent=localized;
      el.setAttribute('dir','rtl');
    });
  }

  function stripReplyPrefix(box){
    var walker=document.createTreeWalker(box,NodeFilter.SHOW_TEXT);
    var node;
    while((node=walker.nextNode())){
      if(node.parentElement&&node.parentElement.classList.contains('tp-jdgm-admin-reply__badge')) continue;
      var original=node.nodeValue||'';
      var cleaned=original.replace(/^\s*(?:>>|»»|››)\s*/,'').replace(/^\s*(?:توني\s*بونس\s*(?:رد|يرد)\s*:|Toni\s*Pons\s*(?:reply|replied)\s*:?)\s*/i,'');
      if(cleaned!==original){node.nodeValue=cleaned;break;}
      if(original.trim()) break;
    }
  }

  function hasRealReplyContent(box){
    var clone=box.cloneNode(true);
    clone.querySelectorAll('.tp-jdgm-admin-reply__badge').forEach(function(el){el.remove();});
    var text=(clone.textContent||'')
      .replace(/[\u200B-\u200D\uFEFF]/g,'')
      .replace(/^\s*(?:>>|»»|››)\s*/,'')
      .replace(/^\s*(?:توني\s*بونس\s*(?:رد|يرد)\s*:|Toni\s*Pons\s*(?:reply|replied)\s*:?)\s*/i,'')
      .replace(/\s+/g,' ')
      .trim();
    if(text) return true;
    return !!clone.querySelector('img,video,audio,iframe,a[href]');
  }

  function polishReplies(root){
    root.querySelectorAll('.jdgm-rev__reply').forEach(function(box){
      stripReplyPrefix(box);

      if(!hasRealReplyContent(box)){
        box.hidden=true;
        box.style.setProperty('display','none','important');
        box.classList.remove('tp-jdgm-admin-reply');
        box.removeAttribute('data-tp-jdgm-reply');
        var emptyBadge=box.querySelector('.tp-jdgm-admin-reply__badge');
        if(emptyBadge) emptyBadge.remove();
        return;
      }

      box.hidden=false;
      box.style.removeProperty('display');
      box.classList.add('tp-jdgm-admin-reply');

      if(!box.querySelector('.tp-jdgm-admin-reply__badge')){
        var badge=document.createElement('span');
        badge.className='tp-jdgm-admin-reply__badge';
        badge.textContent=isArabic()?'رد توني بونس':'Toni Pons Reply';
        box.insertBefore(badge,box.firstChild);
      }
      box.dataset.tpJdgmReply='true';
    });
  }

  function patchReviewSectionSurface(root){
    if(!root) return;

    var spacedSection=root.closest('section.spaced-section');
    var shopifyShell=root.closest('.shopify-section');

    if(spacedSection) spacedSection.classList.add('tp-jdgm-section');
    if(shopifyShell) shopifyShell.classList.add('tp-jdgm-section-shell');

    if(document.getElementById('tp-jdgm-runtime-fixes')) return;
    var style=document.createElement('style');
    style.id='tp-jdgm-runtime-fixes';
    style.textContent='\n      .tp-jdgm-section-shell,\n      .tp-jdgm-section{background:var(--tp-jm-bg,#FBF7F0)!important;}\n      section.tp-jdgm-section.spaced-section{margin-top:0!important;margin-bottom:0!important;margin-block:0!important;}\n      .tp-jdgm-section>.page-width{background:var(--tp-jm-bg,#FBF7F0)!important;max-width:none!important;padding-left:0!important;padding-right:0!important;}\n      .tp-jdgm-section #judgeme_product_reviews,\n      .tp-jdgm-section .jdgm-review-widget,\n      .tp-jdgm-section .jdgm-rev-widg,\n      .tp-jdgm-section .jdgm-rev-widg__header,\n      .tp-jdgm-section .jdgm-rev-widg__body,\n      .tp-jdgm-section .jdgm-row-actions,\n      .tp-jdgm-section .jdgm-rev-widg__reviews{background:var(--tp-jm-bg,#FBF7F0)!important;}\n      .tp-jdgm-section .jdgm-rev-widg{border-color:transparent!important;}\n      #judgeme_product_reviews .jdgm-rev__reply[hidden]{display:none!important;}\n    ';
    document.head.appendChild(style);
  }

  function enhance(root){
    localizeReviewCountLabels(document);
    if(!root) return;
    cleanDisplayName(root);
    polishReplies(root);
    patchReviewSectionSurface(root);
    updateStickyOffset();
  }

  function queue(root){
    if(queued) return;
    queued=true;
    window.requestAnimationFrame(function(){queued=false;enhance(root||observedRoot);});
  }

  function findRoot(){
    return document.getElementById('judgeme_product_reviews')||document.querySelector('.jdgm-review-widget');
  }

  function connect(){
    localizeReviewCountLabels(document);
    var root=findRoot();
    if(!root) return;
    if(root===observedRoot&&observer){enhance(root);return;}
    if(observer) observer.disconnect();
    observedRoot=root;
    enhance(root);
    observer=new MutationObserver(function(mutations){
      var changed=mutations.some(function(m){
        return (m.type==='childList'&&m.addedNodes&&m.addedNodes.length)||m.type==='characterData';
      });
      if(changed) queue(root);
    });
    observer.observe(root,{childList:true,subtree:true,characterData:true});
  }

  function init(){
    localizeReviewCountLabels(document);
    connect();
    updateStickyOffset();
  }

  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init,{once:true});
  else init();

  document.addEventListener('jdgm.doneRenderingRevWidget',connect);
  document.addEventListener('shopify:section:load',connect);
  window.addEventListener('load',function(){localizeReviewCountLabels(document);connect();},{once:true});
  window.addEventListener('resize',function(){window.requestAnimationFrame(updateStickyOffset);},{passive:true});

  window.TPJudgeMe={getStickyOffset:getStickyOffset,refresh:connect};
})();
